
import Frame from '@/components/Frame'

export default [
    // 关于净寺
    {
        path: '/about',
        component: Frame,
        children: [
            {
                path: 'historic',
                meta: {
                    pageTitle: '关于净慈',
                    title: '古往今来',
                    cId: 67
                },
                component: () => import('@/views/about/Historic')
            },
            {
                path: 'position',
                meta: {
                    pageTitle: '关于净慈',
                    title: '四方上下',
                    cId: 68
                },
                component: () => import('@/views/about/Position')
            },
            {
                path: 'positionDetail',
                meta: {
                    pageTitle: '关于净慈',
                    title: '四方上下',
                    cId: 68
                },
                component: () => import('@/views/about/PositionDetail')
            },
            {
                path: 'former',
                meta: {
                    pageTitle: '关于净慈',
                    title: '历代祖师',
                    cId: 75
                },
                component: () => import('@/views/about/Former')
            },
            {
                path: 'formerDetail',
                meta: {
                    pageTitle: '关于净慈',
                    title: '',
                    cId: 75
                },
                component: () => import('@/views/about/FormerDetail')
            },

        ]
    },
    // 净慈法务
    {
        path: '/fawu',
        component: Frame,
        children: [
            {
                path: 'index',
                meta: {
                    pageTitle: '净慈法务',
                    title: '净慈法务',
                    cId: 82
                },
                component: () => import('@/views/fawu/Index')
            },
            {
                path: 'anyang',
                meta: {
                    pageTitle: '净慈法务',
                    title: '愿生安养',
                    cId: 82
                },
                component: () => import('@/views/fawu/anyang/Index')
            },
            // 法会
            {
                path: 'fahui',
                meta: {
                    pageTitle: '净慈法务',
                    title: '年度法会',
                    needLogin: true,
                    cId: 79
                },
                component: () => import('@/views/fawu/fahui/Index')
            },
            {
                path: 'fahui/sub-list',
                meta: {
                    pageTitle: '净慈法务',
                    title: '华严法会',
                    parentMenu: 'fahui',
                    cId: 79,
                    // 需要实名
                    needReal: true,
                    // 未实名重定向
                    realRedirect: '/fawu/fahui'
                },
                component: () => import('@/views/fawu/fahui/SubList')
            },
            {
                path: 'fahui/dagongdezhu',
                meta: {
                    pageTitle: '净慈法务',
                    title: '大功德主',
                    parentMenu: 'fahui',
                    cId: 79,
                    // 需要实名
                    needReal: true,
                    // 未实名重定向
                    realRedirect: '/fawu/fahui'
                },
                component: () => import('@/views/fawu/fahui/DaGongDeZhu')
            },
            {
                path: 'fahui/sub-detail',
                meta: {
                    pageTitle: '净慈法务',
                    title: '供奉详情',
                    parentMenu: 'fahui',
                    cId: 79,
                    // 需要实名
                    needReal: true,
                    // 未实名重定向
                    realRedirect: '/fawu/fahui'
                },
                component: () => import('@/views/fawu/fahui/SubDetail')
            },
            {
                path: 'fahui/reg-detail',
                meta: {
                    pageTitle: '净慈法务',
                    parentMenu: 'fahui',
                    cId: 79,
                    // 需要实名
                    needReal: true,
                    // 未实名重定向
                    realRedirect: '/fawu/fahui'
                },
                component: () => import('@/views/fawu/fahui/RegDetail')
            },
            {
                path: 'fahui/record',
                meta: {
                    title: '登记信息',
                    needLogin: true,
                    parentMenu: 'fahui',
                    cId: 79,
                    // 需要实名
                    needReal: true,
                    // 未实名重定向
                    realRedirect: '/fawu/fahui'
                },
                component: () => import('@/views/fawu/fahui/Record')
            },
            {
                path: 'fahui/reg-record',
                meta: {
                    title: '报名登记',
                    needLogin: true,
                    parentMenu: 'fahui',
                    cId: 79,
                    // 需要实名
                    needReal: true,
                    // 未实名重定向
                    realRedirect: '/fawu/fahui'
                },
                component: () => import('@/views/fawu/fahui/RegRecord')
            },
            // 日常佛事
            {
                path: 'foshi',
                meta: {
                    pageTitle: '净慈法务',
                    title: '日常佛事',
                    needLogin: true,
                    cId: 80
                },
                component: () => import('@/views/fawu/foshi/Index')
            },
            {
                path: 'foshi/detail',
                meta: {
                    title: '日常佛事',
                    parentMenu: 'foshi',
                    cId: 80,
                    // 需要实名
                    needReal: true,
                    // 未实名重定向
                    realRedirect: '/fawu/foshi'
                },
                component: () => import('@/views/fawu/foshi/Detail')
            },
            {
                path: 'foshi/record',
                meta: {
                    title: '登记信息',
                    needLogin: true,
                    parentMenu: 'foshi',
                    cId: 80,
                    // 需要实名
                    needReal: true,
                    // 未实名重定向
                    realRedirect: '/fawu/foshi'
                },
                component: () => import('@/views/fawu/foshi/Record')
            },
            // 广种福田
            {
                path: 'futian',
                meta: {
                    pageTitle: '净慈法务',
                    title: '广种福田',
                    needLogin: true,
                    cId: 81
                },
                component: () => import('@/views/fawu/futian/Index')
            },
            {
                path: 'futian/detail',
                meta: {
                    title: '在线护持',
                    parentMenu: 'futian',
                    cId: 81,
                    // 需要实名
                    needReal: true,
                    // 未实名重定向
                    realRedirect: '/fawu/futian'
                },
                component: () => import('@/views/fawu/futian/Detail')
            },
            {
                path: 'futian/record',
                meta: {
                    title: '登记信息',
                    needLogin: true,
                    parentMenu: 'futian',
                    cId: 81,
                    // 需要实名
                    needReal: true,
                    // 未实名重定向
                    realRedirect: '/fawu/futian'
                },
                component: () => import('@/views/fawu/futian/Record')
            }
        ]
    },
    // 订单
    {
        path: '/order',
        component: Frame,
        children: [
            {
                path: 'index',
                meta: {
                    pageTitle: '个人中心',
                    title: '订单列表',
                    needLogin: true
                },
                component: () => import('@/views/order/orderIndex')
            },
            {
                path: 'detail',
                meta: {
                    pageTitle: '个人中心',
                    title: '订单详情',
                    needLogin: true
                },
                component: () => import('@/views/order/orderDetail')
            }

        ]
    },
    // 支付
    {
        path: '/pay',
        component: Frame,
        children: [
            {
                path: '/pay/success',
                meta: {
                    title: '支付成功'
                },
                component: () => import('@/views/pay/Success')
            }
        ]
    }
]